// extracted by mini-css-extract-plugin
export var header_bg = "our-story-module--header_bg--Cfrqz";
export var our_story = "our-story-module--our_story--zvR7H";
export var our_story_2 = "our-story-module--our_story_2--zZN0c";